import { PaginationKeyEnum, SorterKeyEnum } from '../general'

export enum ParamKeyEnum {
  DateRange = 'dateRange',
  Curriculum = 'curriculum',
  CourseTitle = 'courseTitle',
  CourseLevel = 'courseLevel',
  SpaceId = 'spaceId',
  FullData = 'fullDataType',
  Page = PaginationKeyEnum.Page,
  Size = PaginationKeyEnum.Size,
  SortBy = SorterKeyEnum.Sortby,
  SortOrder = SorterKeyEnum.SortOrder,
}

export type FullDataType =
  | 'chatSession'
  | 'feedback'
  | 'tag'
  | 'starter'
  | 'theme'
  | 'progressionNextStep'
  | 'careerReadiness'
